<template>
  <div class="mainFrameContainer">
    <div class="rightBox">
      <div class="box_title">
        <p class="title">产品展厅</p>
      </div>
      <div class="rightLook">
<!--        <div class="box_1 r1">
          <dl>
            <dt>物料筛选<span></span></dt>
            <dd class="category_items">
              <table style="width: 100%;border:0">
                <tbody>
                <tr>
                  <td class="td_1" style="width: 58px">类别：</td>
                  <td class="td_r">
                    <a>猪料</a>
                    <a>牛羊料</a>
                    <a>家禽料</a>
                  </td>
                </tr>
                </tbody>
              </table>
            </dd>
            <dd class="brand_items">
              <table style="width: 100%;border:0">
                <tbody>
                <tr>
                  <td class="td_1" style="width: 58px">品牌：</td>
                  <td class="td_r">
                    <a>禾丰</a>
                    <a>天地</a>
                    <a>华康</a>
                    <a>爱普特</a>
                    <a>其他</a>
                  </td>
                </tr>
                </tbody>
              </table>
            </dd>
            <dd class="model_items">
              <table style="width: 100%;border:0">
                <tbody>
                <tr>
                  <td class="td_1" style="width: 58px">规格：</td>
                  <td class="td_r">
                    <a>10kg</a>
                    <a>40kg</a>
                    <a>50kg</a>
                    <a>50kg(粉)</a>
                    <a>散装</a>
                  </td>
                </tr>
                </tbody>
              </table>
            </dd>
          </dl>
        </div>-->
        <div class="box_2 rl">
          <div class="myForm1">
            <input class="put1 bus_query_code" type="text" placeholder="请输入关键词"/>
            <input class="put2 bus_query_product_btn" type="button" value="查询物料"/>
            <input class="put3 bus_batch_addCart_btn" type="button" value="批量加入购物车">
          </div>
        </div>
        <div class="box_3 rl product_items"></div>
        <div class="pagination"></div>
      </div>

      <div class="top" :style="{'max-height': this.timeLineHeight + 'px'}">
        <p style="font-weight: bold;font-size: 24px;margin-left: 20px;margin-top: 24px;">产品展厅</p>
        <div class="container">
          <!--商品模糊查询-->
          <div style="margin: 0px 10px 0px 10px;">
            <el-form :inline="true" :model="queryParams">
              <el-form-item>
                <el-input class="input-style" v-model="queryParams.name" placeholder="请输入要查询的商品名称"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="handleQuery"></el-button>
              </el-form-item>
            </el-form>
          </div>
          <!-- 商品筛选按钮 -->
          <div class="item-class-show">
            <Row>
              <i-col class="item-class-name" span="3">分类:</i-col>
              <i-col class="item-class-select" span="21">
                <el-button v-for="(group,index) in goodGroupsList" :key="index" type="text" @click="handleScreen(group,index)">{{ group.name }}</el-button>
              </i-col><br>
            </Row>
          </div>
          <!-- 商品展示容器 -->
          <div class="goods-box">
            <div class="goods-list-box">
              <div class="goods-list">
                <!--遍历orderGoodsList，并显示所有dom-->
                <div v-if="goodsList.length != 0" class="goods-show-info" v-for="good in goodsList">
                  <!--            <div v-if="goodsList.length != 0" class="goods-show-info" v-for="good in goodsList" style="box-shadow:0 0 10px #000">-->

                  <div class="goods-show-img"  @click="getDetail(good)" >
                    <!--                <router-link to="detail,query:{good}">-->
                    <div style="color: blue">
                      此处有图片(点击查看商品详情)
                    </div>
                    <!--                </router-link>-->
                  </div>
                  <div>
                    <!--                <span class="goods-show-name" v-model="goodDetail.goodName">名称：{{good.goodName}}</span>-->
                    <span class="goods-show-name" >名称：{{good.goodName}}</span>
                  </div>
                  <!--规格型号-->
                  <!--              <div class="goods-show-model" v-model="goodDetail.goodModel">-->
                  <div class="goods-show-model" >
                    <span>规格：{{good.goodModel}}</span>
                  </div>
                  <!--              <div class="goods-show-number" v-model="goodDetail.goodNumber">-->
                  <div class="goods-show-number" >
                    <span>编码：{{good.goodNumber}}</span>
                  </div>
                  <!--              <div class="goods-show-shortName" v-model="goodDetail.goodShortName">-->
                  <div class="goods-show-shortName" >
                    <span>简称：{{good.goodShortName}}</span>
                  </div>
                  <!--              <div class="goods-show-RegisteredMark" v-model="goodDetail.goodRegisteredMark">-->
                  <div class="goods-show-RegisteredMark" >
                    <span>品牌：{{good.goodRegisteredMark}}</span>
                  </div>
                  <!--              <div class="goods-show-RegisteredMark" v-model="goodDetail.goodRegisteredMark">-->
                  <!--                <span>id：{{good.goodOrgSaleId}}</span>-->
                  <!--              </div>-->
                  <div style="margin-top: 10px">
                    吨数：
                    <el-input-number v-model="goodDetail.weight" :min="0" size="mini" label="吨数"></el-input-number><br>
                    包数：
                    <el-input-number v-model="goodDetail.amount" :min="1" size="mini" label="吨数" style="margin-top: 6px"></el-input-number>
                  </div>
                  <div>
                    <el-button class="goods-show-addCartBtn" @click="addCart(good)">加入购物车</el-button>
                    <el-button class="goods-show-collectBtn" @click="addFavorites(good)">收藏</el-button>
                  </div>

                </div>
                <!--            <div class="else-div" style="margin-top: 20px" v-else>-->
                <!--            </div>-->
              </div>

            </div>
          </div>
          <div style="margin: 10px; text-align: right">
            <el-pagination
              small
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="queryParams.current"
              :page-sizes="[10, 20, 30, 50]"
              :page-size="queryParams.size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div>
          <div class="goods-page">
            <Page :total="100" show-sizer></Page>
          </div>
        </div>
        <!--    <Spin size="large" fix v-if="isLoading"></Spin>-->
      </div>
    </div>
  </div>
</template>

<script>
import {queryByKey, queryPageList, queryScreenPageList} from "@/api/system/good";
import {queryList} from "@/api/system/material_group";
import {saveCart} from "@/api/system/cart";
import {saveFavorites} from "@/api/system/favorites";
// import JSON from "svg-sprite-loader/lib/utils";
export default {
  name: 'GoodsList',
  beforeRouteEnter (to, from, next) {
    window.scrollTo(0, 0);
    next();
  },
  data () {
    return {
      searchItem: '',
      isAction: [ true, false, false ],
      timeLineHeight: "",
      total:0,
      queryParams: {
        id: '',
        name: '',
        number:'',
        shortName:'',
        model:'',
        registeredMark:'',
        isDeleted: 0,
        current: 0,
        size: 30
      },

      queryGroupsParams: {
        id: '',
        parent_id: '',
        level: '',
        name: '',
        is_deleted: 0,
      },
      goodDetail:{
        // goodName:'',
        // goodModel:'',
        // goodNumber:'',
        // goodShortName:'',
        // goodRegisteredMark:'',
        weight: '0',
        amount: '1',
      },

      goodCartParams:{
        goodsId:'',
        goodsCode:'',
        goodsName:'',
        goodsRule:'',
        goodsAlias:'',
        logo:'',
        weight:'',
        amount:'',
        orgSaleId:'',
        addData:'',
        modifyData:'',
        // isPick:'false',
        // totalWeight:'',
        // totalAmount:'',
      },

      goodsList:[],//商品集合
      goodGroupsList:[],//商品种类集合
      orgSaleId: 'PoEAAAGZRbbM567U',

    };
  },
  computed: {
  },
  methods: {
    handleSizeChange(val) {
      this.queryParams.size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.queryParams.current = val;
      this.getList();
    },
    handleQuery() {
      this.queryParams.current = 0;
      //初始化数据
      this.reset();
      this.getListByKey();
    },
    handleScreen(group,index) {
      this.queryParams.name = group.name;
      this.queryParams.id = group.id;
      this.queryParams.current = 0;
      this.getScreenList();

    },
    reset(){
      this.goodsList=[];
    },
    getDetail(good){
      // console.log(good.goodName);
      // console.log(good.goodId);
      this.$router.push({
        path:'/product/detail',
        query:{
          id:good.goodId,
        }
      })
    },
    addCart(good){
      // console.log(good);
      this.goodCartParams.goodsId=good.goodId;
      this.goodCartParams.goodsCode=good.goodNumber;
      this.goodCartParams.goodsName=good.goodName;
      this.goodCartParams.goodsRule=good.goodModel;
      this.goodCartParams.goodsAlias=good.goodShortName;
      if (good.goodRegisteredMark != null && good.goodRegisteredMark != '') {
        this.goodCartParams.logo = good.goodRegisteredMark;
      } else {
        this.goodCartParams.logo = '无';
      }
      this.goodCartParams.weight=this.goodDetail.weight;
      this.goodCartParams.amount=this.goodDetail.amount;
      this.goodCartParams.orgSaleId = this.orgSaleId;
      let goodsList = [];
      goodsList.push(this.goodCartParams)
      console.log(goodsList)
      // saveCart(this.goodCartParams).then(res => {
      saveCart(goodsList).then(res => {
        if(res.code == 200){
          this.$message({
            offset:300,
            message:'添加到购物车成功',
            type:'success',
          })
        }else{
          this.$message({
            offset:300,
            message:'添加到购物车失败',
            type:'error',
          })
        }
      });
    },
    addFavorites(good) {
      this.goodCartParams.goodsId = good.goodId;
      this.goodCartParams.goodsCode = good.goodNumber;
      this.goodCartParams.goodsName = good.goodName;
      this.goodCartParams.goodsRule = good.goodModel;
      this.goodCartParams.goodsAlias = good.goodShortName;
      if (good.goodRegisteredMark != null && good.goodRegisteredMark != '') {
        this.goodCartParams.logo = good.goodRegisteredMark;
      } else {
        this.goodCartParams.logo = '无';
      }
      this.goodCartParams.orgSaleId = good.goodOrgSaleId;
      let goodsList = [];
      goodsList.push(this.goodCartParams)
      console.log(goodsList)
      saveFavorites(goodsList).then(res => {
        if(res.code == 200){
          this.$message({
            offset:300,
            message:'收藏成功',
            type:'success',
          })
        }else {
          this.$message({
            offset:300,
            message:'收藏失败',
            type:'error',
          })
        }
      })
    },
    getGroupsList(){
      queryList(this.orgSaleId).then(res =>{
        console.log(res.data)
        this.goodGroupsList = [];
        for(let i in res.data){
          let group = {};
          if( res.data[i].level = 4) {
            group.id = res.data[i].id;
            group.parent_id = res.data[i].parentId;
            group.name = res.data[i].name;
            group.level = res.data[i].level;
            group.number = res.data[i].number;
            this.goodGroupsList.push(group);
          }
        }
      })

    },
    getList (){
      this.loading = true;
      console.log(this.queryParams)
      queryPageList(this.queryParams).then(res => {
        console.log(res.data)
        if(res.data.records.length > 0){
          this.total = res.data.total;
          this.goodsList = [];
          for(let i in res.data.records){
            let good = {};
            good.goodName =res.data.records[i].name;
            good.goodNumber = res.data.records[i].number;
            good.goodModel = res.data.records[i].model;
            good.goodId = res.data.records[i].id;
            good.goodRegisteredMark = res.data.records[i].registeredMark;
            good.goodShortName = res.data.records[i].shortName;
            good.goodOrgSaleId = res.data.records[i].orgSales[0].id;
            this.goodsList.push(good);
          }
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    getListByKey (){
      this.loading = true;
      queryByKey(this.queryParams).then(res => {
        if(res.data.records.length > 0){
          this.total = res.data.total;
          this.goodsList = [];
          for(let i in res.data.records){
            let good = {};
            good.goodName =res.data.records[i].name;
            good.goodNumber = res.data.records[i].number;
            good.goodModel = res.data.records[i].model;
            good.goodId = res.data.records[i].id;
            good.goodRegisteredMark = res.data.records[i].registeredMark;
            good.goodShortName = res.data.records[i].shortName;
            good.goodOrgSaleId = res.data.records[i].orgSales[0].id;
            // console.log(res.data.records[i].orgSales[0].id);
            this.goodsList.push(good);
          }
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    getScreenList (){
      this.loading = true;
      // console.log(this.queryParams);

      queryScreenPageList(this.queryParams).then(res => {
        //初始化goodsList
        this.reset();
        if(res.data.records.length > 0){
          this.total = res.data.records.total;
          this.goodsList = [];
          for(let i in res.data.records){
            let good = {};
            good.goodName =res.data.records[i].name;
            good.goodNumber = res.data.records[i].number;
            good.goodModel = res.data.records[i].model;
            good.goodId = res.data.records[i].id;
            good.goodRegisteredMark = res.data.records[i].registeredMark;
            good.goodShortName = res.data.records[i].shortName;
            good.goodOrgSaleId = res.data.records[i].orgSales[0].id;
            // console.log(res.data.records[i].orgSales[0].id);
            this.goodsList.push(good);
          }
        }
      }).catch(() => {
        this.loading = false;
      });
    },
  },

  created () {
    this.getList();
    this.getGroupsList();
  },
  mounted () {
    this.searchItem = this.$route.query.sreachData;
    this.timeLineHeight = document.documentElement.clientHeight -100;
    window.onresize = () => {
      this.timeLineHeight = document.documentElement.clientHeight;
    };
  },
  components: {
  },
};
</script>

<style lang="less" scoped>

div{
  display: block;
}
ul, li, a, p, dl, dd, dt{
  padding: 0;
  margin: 0;
  list-style-type: none;
  text-decoration: none;
}
.mainFrameContainer {
  position: absolute;
  top: 20px;
  left: 10px;
  bottom: 0;
  right: 0;
  overflow: hidden;
  z-index: 4;
  overflow-y: auto;
}
.rightBox{
  width: auto;
}
.rightListBox{
  padding: 18px 30px 20px 20px;
}
.rightLook {
  margin-bottom: 10px;
  margin-top: 15px;
  width: 100%;
  color: #6a5c5c;
  font-size: 12px;
  display: block;
}
a{
  display: block;
  width: 365px;
  height: 176px;
  background: #FFFFFF;
  border:1px solid #E5E5E5;
  float:left;
  margin-right: 16px;
  margin-bottom: 16px;
}
a:hover{
  border-color: red;
}
p{
  font-size: 16px;
  color: #000000;
  line-height: 22px;
  margin-bottom: 12px;
  padding-left: 30px;
  padding-right: 30px;
}
span{
  color: #ff1500;
}
.title {
  display: block;
  font-size: 24px;
  font-weight: bold;
  padding-left: 0;
}
.button{
  color: #FFFFFF;
  text-align: center;
  line-height: 30px;
  width: 100px;
  height: 30px;
  background: #BE1304;
  margin-bottom: 15px;
}
.box_1 dl dd{
  padding: 16px 42px;
  border-bottom: 1px solid #e5e5e5;
}
.rightLook .rl {
  width: 100%;
  border: 1px solid #cfcfcf;
  margin-bottom: 14px;
}
.rightLook .box_1 dl dd {
  padding: 16px 42px;
  border-bottom: 1px solid #e5e5e5;
}
.rightLook .box_1 dl dt {
  height: 38px;
  line-height: 38px;
  background: #f5f5f5;
  font-size: 14px;
  font-family: "微软雅黑";
  color: #12110f;
  padding-left: 20px;
}
.rightLook .box_1 dl dd table td.td_l {
  line-height: 28px;
  color: #302c2a;
  font-size: 14px;
  font-family: "微软雅黑";
}
.rightLook .box_2 .myForm1 {
  padding: 24px 26px;
}
.myForm1 input {
  border: none;
  margin-right: 6px;
}
.myForm1 input.put1 {
  width: 220px;
  padding-left: 10px;
  height: 32px;
  line-height: 32px;
  border-top: 2px solid #dedede;
  border-left: 1px solid #dedede;
  color: #a3a3a3;
  background: #f2f2f2;
  float: left;
}
.myForm1 input.put2 {
  font-size: 14px;
  padding: 0px 30px;
  height: 36px;
  font-family: "微软雅黑";
  color: #fff;
  background: #201c70;
  float: left;
}
.myForm1 input.put3 {
  padding: 0 30px;
  height: 36px;
  font-family: "微软雅黑";
  color: #fff;
  background: #be1304;
}



.top{
  /* 始终显示滚动条 */
  overflow-y: scroll
}
.container {
  margin: 10px 10px;
  width: 93%;
  min-width: 1000px;
}

.seckill-price{
  margin-right: 5px;
  font-size: 25px;
  font-weight: bold;
}
.goods-box {
  display: flex;
}
/* ---------------侧边广告栏开始------------------- */
.as-box {
  width: 200px;
  border: 1px solid #ccc;
}
.item-as-title{
  width: 100%;
  height: 36px;
  color: #B1191A;
  line-height: 36px;
  font-size: 18px;
}
.item-as-title span:first-child{
  margin-left: 20px;
}
.item-as-title span:last-child{
  float: right;
  margin-right: 15px;
  font-size: 10px;
  color: #ccc;
}
.item-as{
  width: 160px;
  margin: 18px auto;
}
.item-as-img{
  width: 160px;
  height: 160px;
  margin: 0px auto;
}
.item-as-price span{
  font-size: 18px;
}
.item-as-intro{
  margin-top: 5px;
  font-size: 12px;
}
.item-as-selled{
  margin-top: 5px;
  font-size: 12px;
}
.item-as-selled span{
  color: #005AA0;
}
/* ---------------侧边广告栏结束------------------- */
/* ---------------商品标签栏开始------------------- */
.item-class-show {
  margin: 15px auto;
  width: 100%;
}
.item-class-group {
  margin-top: 1px;
  height: 45px;
  border-bottom: 1px solid #ccc;
}
.item-class-group:first-child {
  border-top: 1px solid #ccc;
}
.item-class-name {
  /*padding-left: 15px;*/
  line-height: 44px;
  color: #666;
  font-weight: bold;
  background-color: #f3f3f3;
}
.item-class-name:first-child {
  line-height: 43px;
}
.item-class-select span {
  margin-left: 15px;
  width: 160px;
  color: #005aa0;
  line-height: 45px;
  cursor: pointer;
}
/* ---------------商品标签栏结束------------------- */

/* ---------------商品栏开始------------------- */
.goods-list-box {
  margin-left: 15px;
  padding: 10px;
  width: 100%;
  /*border: 1px solid black;*/
}
.goods-list-tool{
  width: 100%;
  height: 38px;
  border: 1px solid #ccc;
  background-color: #F1F1F1;
}
.goods-list-tool ul{
  padding-left: 15px;
  list-style: none;
}
.goods-list-tool li{
  cursor: pointer;
  float: left;
}
.goods-list-tool span{
  padding: 5px 8px;
  border: 1px solid #ccc;
  border-left: none;
  line-height: 36px;
  background-color: #fff;
}
.goods-list-tool span:hover{
  border: 1px solid #E4393C;
}
.goods-list-tool i:hover{
  color: #E4393C;
}
.goods-list-tool-active {
  color: #fff;
  border-left: 1px solid #ccc;
  background-color: #E4393C !important;
}

.goods-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.goods-show-info{
  box-shadow:0 0 10px #000;
  width: 240px;
  padding: 10px;
  /*margin: 15px 0px;*/
  /*margin: 15px;*/
  margin-left: 45px;
  margin-top: 20px;
  border: 1px solid #fff;
  /*cursor: pointer;*/
  float:left;
}
.goods-show-info:hover{
  border: 1px solid #ccc;
  box-shadow: 0px 0px 15px #ccc;
}
.goods-show-name {
  font-size: 15px;
  color: #FF0000;
  margin-top: 30px;
}
.goods-show-img{
  font-size: 17px;
  height: 220px;
  border: 1px solid black;
  cursor:pointer;
  /*box-shadow:0 0 10px #000*/
}

.goods-show-model{
  font-size: 17px;
  margin-top: 6px;
  color: #FF0000;
}
.goods-show-number{
  font-size: 17px;
  margin-top: 6px;
}
.goods-show-shortName{
  font-size: 17px;
  margin-top: 6px;
  color: #FF0000;
}
.goods-show-RegisteredMark{
  font-size: 17px;
  margin-top: 6px;
}
.goods-show-addCartBtn{
  background-color: #FF0000;
  font-size: 17px;
  color: #FFFFFF;
  margin-top: 6px;
}
.goods-show-collectBtn{
  background-color: #FF0000;
  font-size: 17px;
  margin-left: 25px;
  color: #FFFFFF;
  margin-top: 6px;
}


.goods-show-num span{
  color: #005AA0;
  font-weight: bold;
}
.goods-show-seller{
  font-size: 12px;
  color:#E4393C;
}
.goods-page {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}
/* ---------------商品栏结束------------------- */
</style>
